import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

/** Hinweis der Zielseiten, wenn ein KI-Ergebnis nach Ablauf der Aufbewahrung geloescht ist (NEX-1570 AK7). */
@Component({
  selector: 'app-ki-ergebnis-abgelaufen',
  imports: [TranslatePipe],
  templateUrl: './ki-ergebnis-abgelaufen.component.html',
  styleUrl: './ki-ergebnis-abgelaufen.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KiErgebnisAbgelaufenComponent {}
